<template>
  <b-form-group
    :id="`${id}_Group`"
    :label-for="id"
    :class="{required: isRequired}"
    :description="description">
    <template slot="label"><span class="label">{{labelText}}</span><i v-if="helpText" class="fas fa-question-circle help-icon" v-b-popover.hover.right.html="helpText" :title="helpTitle"></i></template>
    <b-form-input
      :id="id"
      :type="type"
      :value="value"
      :maxlength="maxLength"
      :min="min"
      :max="max"
      :required="isRequired"
      :aria-describedby="`${id}_Feedback`"
      :state="isValid"
      :placeholder="placeholder"
      @input="input"/>
    <b-form-invalid-feedback :id="`${id}_Feedback`"><slot name="feedback"/></b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import helpers from "../helpers";

export default {
  mixins: [helpers],
  props: {
    type: {
      type: String,
      default: "text"
    },
    maxLength: {
      type: [String, Number],
      default: null
    },
    max: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    }
  }
};
</script>

<style>
</style>
